module.exports = __webpack_public_path__ + "media/images/candidat-959e604d0d8d916d70d90789e49122c0.svg";